import { AssetManager } from 'components/sharpr/assetManager/AssetManager';
import { ApiResourcify } from 'components/sharpr/api/ApiResourcify';

export function TranslationOriginalRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.TranslationOriginal', {
		url: '/post/:id/original/:language',
		controllerAs: 'vm',
		controller: TranslationOriginalCtrl,
		templateUrl: '/ng/hub/Translation/Original/TranslationOriginalCtrl.html?' + window.BUILD,
		resolve: {
			style: () => AssetManager.css('/ng/hub/Translation/Original/TranslationOriginalCtrl.css'),
			$title: () => 'Original Text',
			originalPost: ApiResourcify.endpoint('/v2/posts/:id/original/:language'),
		},
	});
}

export class TranslationOriginalCtrl {
	constructor(originalPost) {
		'ngInject';
		this.originalPost = originalPost;
	}
}
